import { config } from '@/configs/env';
import { apiFetch } from '@/lib/api-service';
import type { SearchProductPayload, SearchServiceResult } from '@/types';

import { fetchDataFromCookies } from './util/cookies.util';

export async function searchProduct(
  payload: SearchProductPayload
): Promise<SearchServiceResult> {
  const { accessToken } = fetchDataFromCookies();
  const response = await apiFetch<SearchServiceResult>(
    `${config.LOTUS_SEARCH_ENDPOINT}/indexes/products/search`,
    {
      cache: 'force-cache',
      revalidate: 300,
      body: payload,
      headers: {
        ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
      },
      method: 'POST',
    }
  );

  return response;
}
